// extracted by mini-css-extract-plugin
export default {"wrapper":"Services_wrapper__6k9nO","list":"Services_list__RJB8V"};